<template>
  <div>
    <h1>Categories</h1>
    <v-alert :value="true" type="info">Select category</v-alert>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="categories"
      class="elevation-1"
      v-if="categories"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              small
              :to="{ name: 'quoteCategory', params: { id: props.item.id } }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.shortname }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-btn @click="migrateRuleSets" v-if="$keycloak.hasRealmRole('root')"
      >Migrate rule sets</v-btn
    >
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Categories",
  metaInfo() {
    return {
      title: "Categories",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      categories: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    async fetchCategories() {
      const response = await nbmlaw.get(`/cors/admin/file/categories`);
      // console.log(response.data);
      this.categories = response.data;
    },
    async migrateRuleSets() {
      await nbmlaw.post(`/cors/admin/sales/migrateRulesets`, null);
      console.log("Migration finished ok");
    }
  },
  created() {
    this.fetchCategories();
  }
};
</script>